/*eslint-disable */

import app_header from '../components/public/common/header/index.vue';

export default {
  name: 'app',
  components: {
    'app-header': app_header 
  },
  props: [],
  data () {
    return {
       
    }
  },
  computed: {

  }, 
  mounted() {
  },
  methods: {

  }
}
